import { Injectable } from '@angular/core';
import { NgRedux, ObservableStore } from '@angular-redux/store';
import { IAppState } from '../../../../store/model';
import { StoreReducers } from '../../../../store/root.reducer';
import { StoreKeys } from '../../../models/store-keys';
import { NexiaBasketActionConstant, nexiaBasketReducer, NexiaBasketState } from '../reducer/nexia-basket.reducer';
import { NexiaBasketObject, NexiaBasketObjectKeys } from '../../../models/nexia-basket-object';

@Injectable({
  providedIn: 'root'
})
export class NexiaBasketAction {
  private localStore: ObservableStore<NexiaBasketState>;

  constructor(
    private ngRedux: NgRedux<IAppState>
  ) {
    this.localStore = this.ngRedux.configureSubStore([StoreReducers.DYNAMIC_SUB_STORES, StoreKeys.NEXIA_BASKET], nexiaBasketReducer);
  }

  public loadStarted(): void {
    this.localStore.dispatch({
      type: NexiaBasketActionConstant.LOAD_NEXIA_BASKET_ITEMS_START
    });
  }

  public loadSucceeded(datas: {[key: string]: NexiaBasketObject[]}): void {
    this.localStore.dispatch({
      type: NexiaBasketActionConstant.LOAD_NEXIA_BASKET_ITEMS_SUCCEEDED,
      payload: datas
    });
  }

  public loadFailed(error: any): void {
    this.localStore.dispatch({
      type: NexiaBasketActionConstant.LOAD_NEXIA_BASKET_ITEMS_FAILED,
      error: error
    });
  }

  public removeErrorFromStore(): void {
    this.localStore.dispatch({
      type: NexiaBasketActionConstant.REMOVE_ERROR_FROM_STORE
    });
  }

  public setNexiaBasketObjectsDetails(datas: {[key: string]: NexiaBasketObject[]} ): void {
    this.localStore.dispatch({
      type: NexiaBasketActionConstant.LOAD_NEXIA_BASKET_ITEMS_DETAILS_SUCCEEDED,
      payload: datas
    });
  }

  public emptyNexiaBasketObjects( nexiaBasketObjectKey: NexiaBasketObjectKeys ): void {
    const emptydata: {[key: string]: NexiaBasketObject[]} = {};
    emptydata[nexiaBasketObjectKey] = [];

    this.localStore.dispatch({
      type: NexiaBasketActionConstant.EMPTY_NEXIA_BASKET_ITEMS_SUCCEEDED,
      payload: emptydata
    });
  }
}
